import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import AnimatedSection from './AnimatedSection';

const HowItWorksImageSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <AnimatedSection animation="fade-up">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#214140' }}>
              How It Works
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Four simple steps to safer, faster patient care
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection animation="scale-up" delay={200}>
          <div className="max-w-4xl mx-auto">
            <img
              src="/images/products/cordflex_instructions.svg"
              alt="How Cordflex Works - Four simple steps: Clip it, Organize, Move freely, Dispose"
              className="w-full shadow-lg"
            />
          </div>
        </AnimatedSection>

        <AnimatedSection animation="fade-up" delay={400}>
          <div className="text-center mt-12">
            <Button
              className="px-8 py-4 text-lg font-semibold hover:opacity-90 transition-opacity duration-200"
              style={{ backgroundColor: '#214140', color: 'white' }}
              onClick={() => window.location.href = '/how-it-works'}
            >
              Learn More
              <ArrowRight className="h-5 w-5 ml-2" />
            </Button>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default HowItWorksImageSection;
